// gatsby-browser.js
export const onInitialClientRender = () => {
  const tryBindConsentLink = () => {
    const link = document.querySelector(".termly-display-preferences");

    if (
      link &&
      window.Termly &&
      typeof window.Termly.displayPreferences === "function"
    ) {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        window.Termly.displayPreferences();
      });
    }
  };

  if (document.readyState === "complete") {
    tryBindConsentLink();
  } else {
    window.addEventListener("load", tryBindConsentLink);
  }
};
